import i18next from "i18next"

import type { ExampleQuestion } from "@/types"

type QuestionsByLanguage = {
  [key: string]: ExampleQuestion[] | undefined
}

export function getExampleQuestions(
  exampleQuestions: ExampleQuestion[] | QuestionsByLanguage
): ExampleQuestion[] {
  // Handle array input (old config format)
  if (Array.isArray(exampleQuestions)) {
    return exampleQuestions
  }

  // Handle object input (new config format with language support)
  const currentLanguage = i18next.language
  const questions = exampleQuestions[currentLanguage]
  if (questions) return questions

  const fallbackQuestions = exampleQuestions.sv
  return fallbackQuestions ?? []
}
